export default class Style {
	static background(src) {
		return {
			backgroundImage: 'url(' + src + ')'
		};
	}
}